import { SxProps, Theme } from "@mui/material";
import { couleurs, polices } from "../../theme/tokens";

/**
 * Styles partagés par les écrans d'administration ET par les formulaires
 * citoyen réutilisés côté admin (OnboardingFormParts, importés depuis
 * Newcitizen/Editcitizen/Myprofile). Source unique — ne pas redéfinir ces
 * valeurs dans les vues.
 *
 * Les couleurs viennent de `src/theme/tokens.ts` (palette de l'app mobile).
 * Tout ce qui concerne les composants MUI eux-mêmes (champs, boutons,
 * tableaux, dialogues) est réglé dans `src/theme/index.ts`, pas ici.
 */

/** Titre de section d'un formulaire (Actualités, Calendrier…). */
export const sectionTitleSx: SxProps<Theme> = {
    color: couleurs.BleuClair,
    fontSize: "30px",
    fontFamily: polices.extraGras,
    fontWeight: 800,
    pb: 3,
    pt: 4,
};

/** Titre d'étape d'un formulaire multi-étapes (onboarding citoyen). */
export const stepTitleSx: SxProps<Theme> = {
    color: couleurs.BleuClair,
    fontSize: "24px",
    fontFamily: "Nunito Sans",
    fontWeight: 800,
    pb: "8px",
};

/** Libellé d'un champ de formulaire — repris de l'app (stylesChamps.label). */
export const fieldLabelSx: SxProps<Theme> = {
    color: couleurs.BleuMarin,
    fontSize: "13px",
    fontFamily: polices.gras,
    fontWeight: 700,
    lineHeight: 1.3,
    pb: "15px",
    pl: "4px",
};

/**
 * Libellé de champ "large" (16px) — formulaires citoyen (onboarding,
 * profil) et écrans admin qui en reprennent le gabarit (alertes, ajout
 * d'utilisateur). Même rôle que `fieldLabelSx`, taille de texte différente.
 */
export const fieldLabelLgSx: SxProps<Theme> = {
    color: couleurs.BleuMarin,
    fontSize: "16px",
    fontFamily: "Nunito Sans",
    fontWeight: 700,
    lineHeight: "20px",
    pb: "15px",
};
